'use strict';

exports.__esModule = true;
exports.type = undefined;
exports.reduce = reduce;

var _ron = require('@swarm/ron');

var _ron2 = _interopRequireDefault(_ron);

var _ronUuid = require('@swarm/ron-uuid');

var _ronUuid2 = _interopRequireDefault(_ronUuid);

var _iheap = require('./iheap');

var _iheap2 = _interopRequireDefault(_iheap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var heap = new _iheap2.default(_iheap.eventComparatorDesc);

function reduce(batch) {
  var ret = new _ron.Frame();
  if (!batch.length) return ret;

  for (var _iterator = batch, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var frame = _ref;

    if (batch.length === 1) return frame;
    for (var _iterator2 = frame, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var op = _ref2;

      var head = new _ron2.default(type, op.uuid(1), op.uuid(2), _ronUuid.ZERO, undefined, _ron.FRAME_SEP);

      var theLastOne = _ron2.default.fromString(batch.frames[batch.length - 1].toString());
      if (theLastOne) head.event = theLastOne.event;

      ret.push(head);

      heap.clear();
      heap.put(batch);

      while (!heap.eof()) {
        var current = heap.current();
        if (!current || current.event.sep !== '+') break;
        ret.pushWithTerm(current, ',');
        heap.nextPrim();
      }
      return ret;
    }
  }
  return ret;
}

var type = exports.type = _ronUuid2.default.fromString('log');
exports.default = { reduce: reduce, type: type };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/rdt/lib/log.js
// module id = 74
// module chunks = 0